import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=0c8cc7b0&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"
import style0 from "@/css/home.css?vue&type=style&index=0&id=0c8cc7b0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8cc7b0",
  null
  
)

export default component.exports